export default __webpack_public_path__ + "static/media/breakfast.911a29ca.svg";